import {FC, useMemo, useState} from 'react';
import {Button, Col, Row, Spin, Affix, Skeleton, notification} from 'antd';
import {PlusOutlined} from '@ant-design/icons';
import {Index} from './Index';
import {IKey, IKeyMethods} from '../apis/diaries/diaries';
import useSWR from 'swr';
import apis from '../apis/apis';
import {Components, newDiary} from './components/components';
import {Link} from 'react-router-dom';


function todayKey(): IKey {
  const today = new Date();
  today.setTime(today.getTime() - 4 * 60 * 60 * 1000); // move forward 4 hours
  return {
    Year: today.getFullYear(),
    Month: today.getMonth() + 1,
    Day: today.getDate(),
  };
}

function showNewDiary(newest?: IKey): boolean {
  if (!newest) {
    return true;
  }
  // today key greater than neweset key
  return IKeyMethods.desc(todayKey(), newest) === -1;
}

export const Diaries: FC = () => {
  const swrDiaries = useSWR('/diaries', apis.diaries.listDiaies);

  const [chosenKey, chooseKey] = useState<IKey>();

  const keys = useMemo(() => swrDiaries.data ? swrDiaries.data.map((d) => d.Key).sort(IKeyMethods.desc) : [], [swrDiaries]);
  const newestKey = keys.length !== 0 ? keys[0] : undefined;
  if (!chosenKey && keys.length !== 0) {
    chooseKey(keys[0]);
  }

  const swrDiary = useSWR(
    chosenKey ? [chosenKey, '/diary/' + IKeyMethods.asString(chosenKey)] : null,
    apis.diaries.getDiary,
  );

  const [creatingNew, setCreatingNew] = useState(false);

  const createNewDiary = async () => {
    setCreatingNew(true);
    const k = todayKey();
    const d = newDiary(k);
    try {
      await apis.diaries.setDiary(d);
      // after set success
      notification.success({message: 'create new diary success'});
      chooseKey(todayKey());
      swrDiaries.mutate();
    } finally {
      // always set creatingNew to false
      setCreatingNew(false);
    }
  };


  return <>
    <Row >
      {/* 24: [2: space][3: index][1: space][16: diary][2: space] */}
      <Col span={3} offset={2} >
        <Affix offsetTop={30}>
          <>
            <div>
              {/* only one child for Affix to avoid warning, see: https://stackoverflow.com/a/67460787  */}
              {showNewDiary(newestKey) ? <>
                <Button type="primary" shape='round' block onClick={createNewDiary}> <PlusOutlined /> 新日记</Button>
                <br />
                <br />
              </> : null}
              {
                swrDiaries.isValidating && !(swrDiaries.data && swrDiaries.data.length === 0) ? <Spin /> : null
              }
              {
                !swrDiaries.isValidating && chosenKey ? <Index keys={keys} onChoose={chooseKey} chosenKey={chosenKey!} /> : null
              }
              <hr />
              <Link to={process.env.PUBLIC_URL + '/diaries_manager'}>管理</Link>
            </div>
          </>
        </Affix>
      </Col>
      <Col span={16} offset={1} >
        {swrDiary.data ? <Spin spinning={creatingNew || swrDiary.isValidating}><Components diary={swrDiary.data} mutate={swrDiary.mutate} /></Spin> : <Skeleton />}
      </Col>
    </Row>
  </>;
};
